import React, { useState, useEffect } from 'react';
import Button from './ui/Button';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 z-50">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="text-sm text-gray-600 mb-4 md:mb-0">
          Utilizamos cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa 
          <a href="/privacy-policy" className="text-purple-600 hover:underline mx-1">Política de Privacidade</a> e 
          <a href="/cookie-policy" className="text-purple-600 hover:underline mx-1">Política de Cookies</a>.
        </div>
        <div className="flex gap-4">
          <Button variant="ghost" size="sm" onClick={handleDecline}>
            Recusar
          </Button>
          <Button size="sm" onClick={handleAccept}>
            Aceitar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
